/**
 * loading组件
 */
import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';


// 组件  loading小图标
export default function Loading() {
  return (<span className='component-loading'><i /></span>);
}

// 组件  全屏的loading
export function LoadingScreen() {
  return (
    <div className='component-loading-screen'>
      <Loading />
    </div>
  );
}

export function LoadingSection() {
  return (
    <div className='component-loading-section'>
      <Loading />
    </div>
  );
}


// api  显示全屏loading
export function show() {
  getInstance().then(function (instance) {
    instance.show();
  });

  return hide;
}

// api  隐藏全屏loading
export function hide() {
  getInstance().then(function (instance) {
    instance.hide();
  });
}

const Component = React.Component;

class ApiContainer extends Component {
  state = {
    show: false
  };

  render() {
    let {show} = this.state;

    if (show) {
      return (<LoadingScreen />);
    } else {
      return null;
    }
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    this.setState({show: false});
  }
}





function getContainerNode() {
  if (getContainerNode.node) {
    return getContainerNode.node;
  }

  let node = getContainerNode.node = document.createElement('div');
  node.className = 'component-loading-api-container';
  document.body.appendChild(node);

  return node;
}

// getInstance();

function getInstance() {
  if (getInstance.instance) {
    return Promise.resolve(getInstance.instance);
  }

  let node = getContainerNode();
  let resolve;
  let promise = new Promise(function (_resolve) {
    resolve = _resolve;
  });

  ReactDOM.render(<ApiContainer ref={(instance) => {
    getInstance.instance = instance;
    resolve(getInstance.instance);
  }} />, node);

  return promise;
}



// WEBPACK FOOTER //
// ./src/components/Loading/index.js